import DosiMegaphone from '@linecorp/dosi-megaphone';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import i18next from 'i18next';
import { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter as Router } from 'react-router-dom';
import { LayerPortal, ViewHeight } from 'yoso';
import { usePatchVault } from '~/components/Dosi/Vault';
import { ApplicationErrorFallback } from '~/components/Error/ApplicationErrorFallback';
import { UrlModalManager } from '~/components/Manager/Modal/UrlModalManager';
import { RouteSwitch } from '~/components/RouteSwitch';
import { CitizenSidebar } from '~/components/Sidebar/Citizen/CitizenSidebar';
import { ToastContainer } from '~/components/Toast';
export type ApplicationProps = {
  queryClient: QueryClient;
};

export const Application = ({ queryClient }: ApplicationProps) => {
  usePatchVault();

  const [lang, setLang] = useState(i18next.resolvedLanguage);

  useEffect(() => {
    i18next.on('languageChanged', () => {
      setLang(i18next.resolvedLanguage);
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ErrorBoundary FallbackComponent={ApplicationErrorFallback}>
          <RouteSwitch key={lang} />
          <CitizenSidebar />
          <ToastContainer />
          <LayerPortal />
          <UrlModalManager />
          <DosiMegaphone />
        </ErrorBoundary>
      </Router>
      <ViewHeight />
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};
